import Chat from "@/components/Chat";

const MessagePage = () => {
  return <Chat />;
};

export default MessagePage;
